import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const WelcomeMessagesQuery: GraphQLTaggedNode = graphql`
	query WelcomeMessagesQuery {
		spaViewContext {
			welcomeMessageEditUrl
			welcomeMessageHtml
			isWelcomeMessageCustomized
			resourceKeys
			resourceContexts
			showWelcomeMessageEditHint
			showEditButton
		}
	}
`;
